var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-6 offset-lg-3 col-12 text-center p-0" },
          [
            _c("div", { staticClass: "card shadow-sm" }, [
              _c(
                "div",
                { staticClass: "card-body", staticStyle: { padding: "0" } },
                [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: { src: "static/img/nimcap/2_1.png", alt: "" }
                  })
                ]
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-6 offset-lg-3 col-12 text-center p-0" },
          [
            _c("div", { staticClass: "card shadow-sm" }, [
              _c(
                "div",
                { staticClass: "card-body", staticStyle: { padding: "0" } },
                [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: { src: "static/img/nimcap/2_2.png", alt: "" }
                  })
                ]
              )
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bced2b9c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bced2b9c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nimcap/Components/Borrower/Step1.vue
// module id = 2268
// module chunks = 0